import { render, staticRenderFns } from "./ActividadResultados.vue?vue&type=template&id=06c7f179&scoped=true"
import script from "./ActividadResultados.vue?vue&type=script&lang=js"
export * from "./ActividadResultados.vue?vue&type=script&lang=js"
import style0 from "./ActividadResultados.vue?vue&type=style&index=0&id=06c7f179&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7f179",
  null
  
)

export default component.exports